import Resume from './Resume.pdf';

export const heroData = {
  name: "Sushant Pardhi",
  title: "Building Digital Products & Scalable Systems",
  summary: "I transform complex problems into elegant, performant code. Specializing in modern React ecosystems and cloud-native architectures that deliver real value.",
  profileCardTitle: "Sushant Pardhi",
  stats: [
    { value: "2+", label: "Years Exp" },
    { value: "10+", label: "Projects" },
    { value: "100%", label: "Passion" }
  ],
  focusAreas: [
    "Fullstack Development",
    "CI/CD",
    "Testing",
    "Performance",
    "Security",
    "Scalability"
  ],
  status: "Open to opportunities",
  ctas: {
    primary: {
      label: "View Projects",
      ariaLabel: "View my projects"
    },
    secondary: {
      label: "View Resume",
      ariaLabel: "View my resume",
      href: Resume,
    }
  }
};
